<template>
    <div>
        <Breadcrumbs main="Admin" submain="" title="Register" />
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12">
                    <px-card>
                        <div slot="with-padding">
                            <div class="form theme-form">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>First Name</label>
                                            <input class="form-control" type="text" placeholder="Enter your first name" v-model="admin.first_name" required style="height: 44px;">
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Last Name</label>
                                            <input class="form-control" type="text" placeholder="Enter your last name" v-model="admin.last_name" required style="height: 44px;">
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Email</label>
                                            <input class="form-control" type="email" placeholder="Enter your email address" v-model="admin.email" required style="height: 44px;">
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Phone No.</label>
                                            <input class="form-control" type="text" placeholder="Enter your phone no." v-model="admin.additional_info.phone_number" style="height: 44px;">
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>NID No.</label>
                                            <input class="form-control" type="text" placeholder="Enter your nid no." v-model="admin.additional_info.nid" style="height: 44px;">
                                        </div>
                                    </div>
                                </div>
    
                                <div class="row">
                                    <div class="col">
                                        <div class="form-group">
                                            <label>Image</label>
                                            <div class="flex items-center">
                                                <img v-if="show_image" style="height: 80px;" :src="show_image">
                                                <input :class="admin.additional_info.photo ? 'ml-4' : 'ml-0'" type="file" accept="image/*" @change="uploadFile">
                                            </div>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="row mt-4">
                                    <div class="col">
                                        <div class="form-group mb-0">
                                            <button @click="onSubmit" class="btn btn-success mr-3" :disabled="isDisabled">Create</button>
                                            <router-link to="/admin/list">
                                                <button class="btn btn-danger" href="#">Go Back</button>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </px-card>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>
    
<script>
    import { mapState } from 'vuex';
    import Datepicker from 'vuejs-datepicker';
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';
    import Multiselect from 'vue-multiselect';
    import Swal from 'sweetalert2/dist/sweetalert2.js'
    import 'sweetalert2/src/sweetalert2.scss'
    
    export default {
        components: {
            vueDropzone: vue2Dropzone,
            Datepicker,
            Multiselect
        },
    
        data() {
            return {
                isDisabled: false,
                admin: {
                    first_name: '',
                    last_name: '',
                    email: '',
                    additional_info: {
                        nid: '',
                        phone_number: '',
                        photo: null
                    }
                },
                show_image: null
            }
        },
    
        methods: {
            uploadFile(e) {
                const image = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e => {
                    this.show_image = e.target.result
                    this.admin.additional_info.photo = e.target.result;
                };
            },
    
            onSubmit() {
                if (!this.admin.first_name || !this.admin.last_name || !this.admin.email) {
                    Swal.fire({
                        title: "Validation error",
                        text: "First name, last name, and email are required.",
                        icon: "error"
                    });
                    return;
                }

                this.isDisabled = true;

                this.$store.dispatch("admin/addAdmin", this.admin).then(response => {
                    if (response.code == 200) {
                        this.isDisabled = false;
                        this.admin.first_name = ''
                        this.admin.last_name = ''
                        this.admin.email = ''
                        this.admin.additional_info.nid = ''
                        this.admin.additional_info.phone_number = ''
                        this.show_image = null
                        Swal.fire({
                            title: "Success!",
                            text: response.password,
                            icon: "success"
                        });
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
            }
        }
    };
</script>
    